import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

interface TransactionFilters {
  page?: number;
  limit?: number;
}

export function useWalletTransactions(filters?: TransactionFilters) {
  return useQuery({
    queryKey: ['walletTransactions', filters],
    queryFn: () => adsService.getWalletTransactions(filters),
  });
}
